import script from "./FechamentosCambioCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./FechamentosCambioCadastro.vue?vue&type=script&setup=true&lang=js"

import "./FechamentosCambioCadastro.vue?vue&type=style&index=0&id=6b9582ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9582ce"]])

export default __exports__